/** Agent login / forgot password — non-English overrides */
export const panelAgentAuthByLang = {
  es: {
    'auth.agent.login.title': 'Acceso de agente',
    'auth.agent.login.subtitle': 'Inicia sesión con tu usuario y contraseña de agente.',
    'auth.agent.login.needAccount': '¿Necesitas cuenta?',
    'auth.agent.login.signUp': 'Registrarse',
    'auth.agent.login.usernameHint': 'Letras y números; los guiones se ignoran (p. ej. AGT-00142 funciona).',
    'auth.agent.login.placeholderUsername': 'Tu usuario de agente',
    'auth.agent.login.placeholderPassword': 'Tu contraseña',
    'auth.agent.login.forgotPassword': '¿Olvidaste la contraseña?',
    'auth.agent.login.signIn': 'Entrar',
    'auth.agent.login.signingIn': 'Entrando…',
    'auth.agent.login.ariaShowPassword': 'Mostrar contraseña',
    'auth.agent.login.ariaHidePassword': 'Ocultar contraseña',
    'auth.agent.login.error.usernameInvalid': 'Usa un usuario válido (letras, números; guiones opcionales).',
    'auth.agent.login.error.passwordRequired': 'La contraseña es obligatoria.',
    'auth.agent.login.error.signInFailed': 'Error al iniciar sesión',
    'auth.agent.login.success.signedIn': 'Sesión iniciada',
    'auth.agent.forgot.title': 'Recuperar contraseña de agente',
    'auth.agent.forgot.subtitle': 'Restablece con tu frase de recuperación de 12 palabras.',
    'auth.agent.forgot.remember': '¿Recuerdas tu contraseña?',
    'auth.agent.forgot.signIn': 'Entrar',
    'auth.agent.forgot.intro': 'Usa el mismo usuario y email de tu cuenta, más la frase guardada al registrarte.',
    'auth.agent.forgot.placeholderUsername': 'Tu usuario de agente',
  },
  de: {
    'auth.agent.login.title': 'Agent-Login',
    'auth.agent.login.subtitle': 'Melden Sie sich mit Ihrem Agenten-Benutzernamen und Passwort an.',
    'auth.agent.login.needAccount': 'Noch kein Konto?',
    'auth.agent.login.signUp': 'Registrieren',
    'auth.agent.login.usernameHint': 'Buchstaben und Zahlen; Bindestriche werden ignoriert (z. B. AGT-00142).',
    'auth.agent.login.placeholderUsername': 'Ihr Agenten-Benutzername',
    'auth.agent.login.placeholderPassword': 'Passwort eingeben',
    'auth.agent.login.forgotPassword': 'Passwort vergessen?',
    'auth.agent.login.signIn': 'Anmelden',
    'auth.agent.login.signingIn': 'Anmeldung…',
    'auth.agent.login.ariaShowPassword': 'Passwort anzeigen',
    'auth.agent.login.ariaHidePassword': 'Passwort ausblenden',
    'auth.agent.login.error.usernameInvalid': 'Gültiger Benutzername (Buchstaben, Zahlen, optionale Bindestriche).',
    'auth.agent.login.error.passwordRequired': 'Passwort ist erforderlich.',
    'auth.agent.login.error.signInFailed': 'Anmeldung fehlgeschlagen',
    'auth.agent.login.success.signedIn': 'Angemeldet',
    'auth.agent.forgot.title': 'Agenten-Passwort vergessen',
    'auth.agent.forgot.subtitle': 'Zurücksetzen mit Ihrer 12-Wort-Wiederherstellungsphrase.',
    'auth.agent.forgot.remember': 'Passwort bekannt?',
    'auth.agent.forgot.signIn': 'Anmelden',
    'auth.agent.forgot.intro': 'Verwenden Sie denselben Benutzernamen und dieselbe E-Mail wie beim Konto plus die bei der Registrierung gespeicherte Phrase.',
    'auth.agent.forgot.placeholderUsername': 'Ihr Agenten-Benutzername',
  },
  fr: {
    'auth.agent.login.title': 'Connexion agent',
    'auth.agent.login.subtitle': 'Connectez-vous avec votre identifiant et mot de passe agent.',
    'auth.agent.login.needAccount': 'Pas de compte ?',
    'auth.agent.login.signUp': 'S\'inscrire',
    'auth.agent.login.usernameHint': 'Lettres et chiffres ; les tirets sont ignorés (ex. AGT-00142).',
    'auth.agent.login.placeholderUsername': 'Votre identifiant agent',
    'auth.agent.login.placeholderPassword': 'Entrez votre mot de passe',
    'auth.agent.login.forgotPassword': 'Mot de passe oublié ?',
    'auth.agent.login.signIn': 'Connexion',
    'auth.agent.login.signingIn': 'Connexion…',
    'auth.agent.login.ariaShowPassword': 'Afficher le mot de passe',
    'auth.agent.login.ariaHidePassword': 'Masquer le mot de passe',
    'auth.agent.login.error.usernameInvalid': 'Identifiant valide (lettres, chiffres, tirets optionnels).',
    'auth.agent.login.error.passwordRequired': 'Le mot de passe est requis.',
    'auth.agent.login.error.signInFailed': 'Échec de la connexion',
    'auth.agent.login.success.signedIn': 'Connecté',
    'auth.agent.forgot.title': 'Mot de passe agent oublié',
    'auth.agent.forgot.subtitle': 'Réinitialisez avec votre phrase de récupération de 12 mots.',
    'auth.agent.forgot.remember': 'Vous vous souvenez du mot de passe ?',
    'auth.agent.forgot.signIn': 'Connexion',
    'auth.agent.forgot.intro': 'Utilisez le même identifiant et e-mail que sur votre compte, plus la phrase enregistrée à l\'inscription.',
    'auth.agent.forgot.placeholderUsername': 'Votre identifiant agent',
  },
  ar: {
    'auth.agent.login.title': 'تسجيل دخول الوكيل',
    'auth.agent.login.subtitle': 'سجّل الدخول باسم المستخدم وكلمة مرور الوكيل.',
    'auth.agent.login.needAccount': 'تحتاج حساباً؟',
    'auth.agent.login.signUp': 'إنشاء حساب',
    'auth.agent.login.usernameHint': 'أحرف وأرقام؛ يُتجاهل الشرطة (مثل AGT-00142).',
    'auth.agent.login.placeholderUsername': 'اسم مستخدم الوكيل',
    'auth.agent.login.placeholderPassword': 'أدخل كلمة المرور',
    'auth.agent.login.forgotPassword': 'نسيت كلمة المرور؟',
    'auth.agent.login.signIn': 'تسجيل الدخول',
    'auth.agent.login.signingIn': 'جارٍ تسجيل الدخول…',
    'auth.agent.login.ariaShowPassword': 'إظهار كلمة المرور',
    'auth.agent.login.ariaHidePassword': 'إخفاء كلمة المرور',
    'auth.agent.login.error.usernameInvalid': 'استخدم اسم مستخدم صالحاً (أحرف وأرقام؛ شرطة اختيارية).',
    'auth.agent.login.error.passwordRequired': 'كلمة المرور مطلوبة.',
    'auth.agent.login.error.signInFailed': 'فشل تسجيل الدخول',
    'auth.agent.login.success.signedIn': 'تم تسجيل الدخول',
    'auth.agent.forgot.title': 'نسيت كلمة مرور الوكيل',
    'auth.agent.forgot.subtitle': 'أعد التعيين بعبارة الاسترداد المكونة من 12 كلمة.',
    'auth.agent.forgot.remember': 'تتذكر كلمة المرور؟',
    'auth.agent.forgot.signIn': 'تسجيل الدخول',
    'auth.agent.forgot.intro': 'استخدم نفس اسم المستخدم والبريد الإلكتروني للحساب، مع العبارة المحفوظة عند التسجيل.',
    'auth.agent.forgot.placeholderUsername': 'اسم مستخدم الوكيل',
  },
  ja: {
    'auth.agent.login.title': 'エージェントログイン',
    'auth.agent.login.subtitle': 'エージェントのユーザー名とパスワードでサインインします。',
    'auth.agent.login.needAccount': 'アカウントをお持ちでないですか？',
    'auth.agent.login.signUp': '登録',
    'auth.agent.login.usernameHint': '英数字。ハイフンは無視されます（例: AGT-00142）。',
    'auth.agent.login.placeholderUsername': 'エージェントユーザー名',
    'auth.agent.login.placeholderPassword': 'パスワードを入力',
    'auth.agent.login.forgotPassword': 'パスワードをお忘れですか？',
    'auth.agent.login.signIn': 'サインイン',
    'auth.agent.login.signingIn': 'サインイン中…',
    'auth.agent.login.ariaShowPassword': 'パスワードを表示',
    'auth.agent.login.ariaHidePassword': 'パスワードを非表示',
    'auth.agent.login.error.usernameInvalid': '有効なユーザー名を入力（英数字、ハイフン可）。',
    'auth.agent.login.error.passwordRequired': 'パスワードは必須です。',
    'auth.agent.login.error.signInFailed': 'サインインに失敗しました',
    'auth.agent.login.success.signedIn': 'サインインしました',
    'auth.agent.forgot.title': 'エージェントパスワードを忘れた',
    'auth.agent.forgot.subtitle': '12語のリカバリーフレーズでリセットします。',
    'auth.agent.forgot.remember': 'パスワードを覚えていますか？',
    'auth.agent.forgot.signIn': 'サインイン',
    'auth.agent.forgot.intro': 'アカウントと同じユーザー名・メールと、登録時に保存したフレーズを使用してください。',
    'auth.agent.forgot.placeholderUsername': 'エージェントユーザー名',
  },
  ko: {
    'auth.agent.login.title': '에이전트 로그인',
    'auth.agent.login.subtitle': '에이전트 사용자 이름과 비밀번호로 로그인하세요.',
    'auth.agent.login.needAccount': '계정이 없으신가요?',
    'auth.agent.login.signUp': '가입',
    'auth.agent.login.usernameHint': '영문·숫자; 하이픈은 무시됩니다(예: AGT-00142).',
    'auth.agent.login.placeholderUsername': '에이전트 사용자 이름',
    'auth.agent.login.placeholderPassword': '비밀번호 입력',
    'auth.agent.login.forgotPassword': '비밀번호를 잊으셨나요?',
    'auth.agent.login.signIn': '로그인',
    'auth.agent.login.signingIn': '로그인 중…',
    'auth.agent.login.ariaShowPassword': '비밀번호 표시',
    'auth.agent.login.ariaHidePassword': '비밀번호 숨기기',
    'auth.agent.login.error.usernameInvalid': '유효한 사용자 이름(영문·숫자, 하이픈 선택)을 입력하세요.',
    'auth.agent.login.error.passwordRequired': '비밀번호가 필요합니다.',
    'auth.agent.login.error.signInFailed': '로그인 실패',
    'auth.agent.login.success.signedIn': '로그인됨',
    'auth.agent.forgot.title': '에이전트 비밀번호 찾기',
    'auth.agent.forgot.subtitle': '12단어 복구 구문으로 재설정합니다.',
    'auth.agent.forgot.remember': '비밀번호가 기억나시나요?',
    'auth.agent.forgot.signIn': '로그인',
    'auth.agent.forgot.intro': '계정과 동일한 사용자 이름·이메일과 가입 시 저장한 구문을 사용하세요.',
    'auth.agent.forgot.placeholderUsername': '에이전트 사용자 이름',
  },
  'zh-CN': {
    'auth.agent.login.title': '代理登录',
    'auth.agent.login.subtitle': '使用代理用户名和密码登录。',
    'auth.agent.login.needAccount': '还没有账户？',
    'auth.agent.login.signUp': '注册',
    'auth.agent.login.usernameHint': '字母和数字；连字符会被忽略（如 AGT-00142）。',
    'auth.agent.login.placeholderUsername': '您的代理用户名',
    'auth.agent.login.placeholderPassword': '输入密码',
    'auth.agent.login.forgotPassword': '忘记密码？',
    'auth.agent.login.signIn': '登录',
    'auth.agent.login.signingIn': '登录中…',
    'auth.agent.login.ariaShowPassword': '显示密码',
    'auth.agent.login.ariaHidePassword': '隐藏密码',
    'auth.agent.login.error.usernameInvalid': '请输入有效用户名（字母、数字，连字符可选）。',
    'auth.agent.login.error.passwordRequired': '密码为必填项。',
    'auth.agent.login.error.signInFailed': '登录失败',
    'auth.agent.login.success.signedIn': '已登录',
    'auth.agent.forgot.title': '代理忘记密码',
    'auth.agent.forgot.subtitle': '使用12词恢复短语重置密码。',
    'auth.agent.forgot.remember': '记得密码？',
    'auth.agent.forgot.signIn': '登录',
    'auth.agent.forgot.intro': '使用与账户相同的用户名和邮箱，以及注册时保存的短语。',
    'auth.agent.forgot.placeholderUsername': '您的代理用户名',
  },
  pt: {
    'auth.agent.login.title': 'Login de agente',
    'auth.agent.login.subtitle': 'Entre com seu usuário e senha de agente.',
    'auth.agent.login.needAccount': 'Precisa de conta?',
    'auth.agent.login.signUp': 'Cadastrar',
    'auth.agent.login.usernameHint': 'Letras e números; hífens são ignorados (ex.: AGT-00142).',
    'auth.agent.login.placeholderUsername': 'Seu usuário de agente',
    'auth.agent.login.placeholderPassword': 'Digite sua senha',
    'auth.agent.login.forgotPassword': 'Esqueceu a senha?',
    'auth.agent.login.signIn': 'Entrar',
    'auth.agent.login.signingIn': 'Entrando…',
    'auth.agent.login.ariaShowPassword': 'Mostrar senha',
    'auth.agent.login.ariaHidePassword': 'Ocultar senha',
    'auth.agent.login.error.usernameInvalid': 'Use um usuário válido (letras, números; hífens opcionais).',
    'auth.agent.login.error.passwordRequired': 'A senha é obrigatória.',
    'auth.agent.login.error.signInFailed': 'Falha ao entrar',
    'auth.agent.login.success.signedIn': 'Conectado',
    'auth.agent.forgot.title': 'Esqueci a senha do agente',
    'auth.agent.forgot.subtitle': 'Redefina com sua frase de recuperação de 12 palavras.',
    'auth.agent.forgot.remember': 'Lembra da senha?',
    'auth.agent.forgot.signIn': 'Entrar',
    'auth.agent.forgot.intro': 'Use o mesmo usuário e e-mail da conta, mais a frase salva no cadastro.',
    'auth.agent.forgot.placeholderUsername': 'Seu usuário de agente',
  },
  it: {
    'auth.agent.login.title': 'Accesso agente',
    'auth.agent.login.subtitle': 'Accedi con username e password agente.',
    'auth.agent.login.needAccount': 'Non hai un account?',
    'auth.agent.login.signUp': 'Registrati',
    'auth.agent.login.usernameHint': 'Lettere e numeri; i trattini sono ignorati (es. AGT-00142).',
    'auth.agent.login.placeholderUsername': 'Il tuo username agente',
    'auth.agent.login.placeholderPassword': 'Inserisci la password',
    'auth.agent.login.forgotPassword': 'Password dimenticata?',
    'auth.agent.login.signIn': 'Accedi',
    'auth.agent.login.signingIn': 'Accesso…',
    'auth.agent.login.ariaShowPassword': 'Mostra password',
    'auth.agent.login.ariaHidePassword': 'Nascondi password',
    'auth.agent.login.error.usernameInvalid': 'Username valido (lettere, numeri; trattini opzionali).',
    'auth.agent.login.error.passwordRequired': 'La password è obbligatoria.',
    'auth.agent.login.error.signInFailed': 'Accesso non riuscito',
    'auth.agent.login.success.signedIn': 'Accesso effettuato',
    'auth.agent.forgot.title': 'Password agente dimenticata',
    'auth.agent.forgot.subtitle': 'Reimposta con la frase di recupero di 12 parole.',
    'auth.agent.forgot.remember': 'Ricordi la password?',
    'auth.agent.forgot.signIn': 'Accedi',
    'auth.agent.forgot.intro': 'Usa lo stesso username e email dell\'account, più la frase salvata alla registrazione.',
    'auth.agent.forgot.placeholderUsername': 'Il tuo username agente',
  },
  ru: {
    'auth.agent.login.title': 'Вход агента',
    'auth.agent.login.subtitle': 'Войдите с именем пользователя и паролем агента.',
    'auth.agent.login.needAccount': 'Нет аккаунта?',
    'auth.agent.login.signUp': 'Регистрация',
    'auth.agent.login.usernameHint': 'Буквы и цифры; дефисы игнорируются (напр. AGT-00142).',
    'auth.agent.login.placeholderUsername': 'Имя пользователя агента',
    'auth.agent.login.placeholderPassword': 'Введите пароль',
    'auth.agent.login.forgotPassword': 'Забыли пароль?',
    'auth.agent.login.signIn': 'Войти',
    'auth.agent.login.signingIn': 'Вход…',
    'auth.agent.login.ariaShowPassword': 'Показать пароль',
    'auth.agent.login.ariaHidePassword': 'Скрыть пароль',
    'auth.agent.login.error.usernameInvalid': 'Допустимое имя (буквы, цифры; дефисы по желанию).',
    'auth.agent.login.error.passwordRequired': 'Пароль обязателен.',
    'auth.agent.login.error.signInFailed': 'Не удалось войти',
    'auth.agent.login.success.signedIn': 'Вы вошли',
    'auth.agent.forgot.title': 'Забыли пароль агента',
    'auth.agent.forgot.subtitle': 'Сбросьте с помощью фразы восстановления из 12 слов.',
    'auth.agent.forgot.remember': 'Помните пароль?',
    'auth.agent.forgot.signIn': 'Войти',
    'auth.agent.forgot.intro': 'Используйте то же имя и email, что у аккаунта, и фразу, сохранённую при регистрации.',
    'auth.agent.forgot.placeholderUsername': 'Имя пользователя агента',
  },
  bn: {
    'auth.agent.login.title': 'এজেন্ট লগইন',
    'auth.agent.login.subtitle': 'এজেন্ট ব্যবহারকারীর নাম ও পাসওয়ার্ড দিয়ে সাইন ইন করুন।',
    'auth.agent.login.needAccount': 'অ্যাকাউন্ট নেই?',
    'auth.agent.login.signUp': 'সাইন আপ',
    'auth.agent.login.usernameHint': 'অক্ষর ও সংখ্যা; হাইফেন উপেক্ষা করা হয় (যেমন AGT-00142)।',
    'auth.agent.login.placeholderUsername': 'আপনার এজেন্ট ব্যবহারকারীর নাম',
    'auth.agent.login.placeholderPassword': 'পাসওয়ার্ড লিখুন',
    'auth.agent.login.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
    'auth.agent.login.signIn': 'সাইন ইন',
    'auth.agent.login.signingIn': 'সাইন ইন হচ্ছে…',
    'auth.agent.login.ariaShowPassword': 'পাসওয়ার্ড দেখান',
    'auth.agent.login.ariaHidePassword': 'পাসওয়ার্ড লুকান',
    'auth.agent.login.error.usernameInvalid': 'বৈধ ব্যবহারকারীর নাম ব্যবহার করুন (অক্ষর, সংখ্যা; হাইফেন ঐচ্ছিক)।',
    'auth.agent.login.error.passwordRequired': 'পাসওয়ার্ড প্রয়োজন।',
    'auth.agent.login.error.signInFailed': 'সাইন ইন ব্যর্থ',
    'auth.agent.login.success.signedIn': 'সাইন ইন হয়েছে',
    'auth.agent.forgot.title': 'এজেন্ট পাসওয়ার্ড ভুলে গেছেন',
    'auth.agent.forgot.subtitle': '১২-শব্দের পুনরুদ্ধার বাক্য দিয়ে রিসেট করুন।',
    'auth.agent.forgot.remember': 'পাসওয়ার্ড মনে আছে?',
    'auth.agent.forgot.signIn': 'সাইন ইন',
    'auth.agent.forgot.intro': 'অ্যাকাউন্টের একই ব্যবহারকারীর নাম ও ইমেইল, এবং সাইনআপে সংরক্ষিত বাক্য ব্যবহার করুন।',
    'auth.agent.forgot.placeholderUsername': 'আপনার এজেন্ট ব্যবহারকারীর নাম',
  },
  hi: {
    'auth.agent.login.title': 'एजेंट लॉगिन',
    'auth.agent.login.subtitle': 'अपने एजेंट उपयोगकर्ता नाम और पासवर्ड से साइन इन करें।',
    'auth.agent.login.needAccount': 'खाता नहीं है?',
    'auth.agent.login.signUp': 'साइन अप',
    'auth.agent.login.usernameHint': 'अक्षर और अंक; हाइफ़न नज़रअंदाज़ (जैसे AGT-00142)।',
    'auth.agent.login.placeholderUsername': 'आपका एजेंट उपयोगकर्ता नाम',
    'auth.agent.login.placeholderPassword': 'पासवर्ड दर्ज करें',
    'auth.agent.login.forgotPassword': 'पासवर्ड भूल गए?',
    'auth.agent.login.signIn': 'साइन इन',
    'auth.agent.login.signingIn': 'साइन इन हो रहा है…',
    'auth.agent.login.ariaShowPassword': 'पासवर्ड दिखाएँ',
    'auth.agent.login.ariaHidePassword': 'पासवर्ड छिपाएँ',
    'auth.agent.login.error.usernameInvalid': 'मान्य उपयोगकर्ता नाम (अक्षर, अंक; हाइफ़न वैकल्पिक)।',
    'auth.agent.login.error.passwordRequired': 'पासवर्ड आवश्यक है।',
    'auth.agent.login.error.signInFailed': 'साइन इन विफल',
    'auth.agent.login.success.signedIn': 'साइन इन हो गया',
    'auth.agent.forgot.title': 'एजेंट पासवर्ड भूल गए',
    'auth.agent.forgot.subtitle': '12-शब्द की रिकवरी वाक्यांश से रीसेट करें।',
    'auth.agent.forgot.remember': 'पासवर्ड याद है?',
    'auth.agent.forgot.signIn': 'साइन इन',
    'auth.agent.forgot.intro': 'खाते के समान उपयोगकर्ता नाम और ईमेल, और साइनअप पर सहेजा गया वाक्यांश उपयोग करें।',
    'auth.agent.forgot.placeholderUsername': 'आपका एजेंट उपयोगकर्ता नाम',
  },
};
